import _ from 'lodash'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router from './router'
import { asyncRouterMap, routerMap } from './router/index'
import store from './store'
import { getToken } from '@/utils/auth'
import * as Sentry from '@sentry/vue'
import { isProduction, isPrerelease } from '@com/config/env.js'
import { NODE_ENV } from '@com/config/env'
import { initChannelList } from '@com/utils/channel'
import { processLogAsyncRouterMap } from '@com/utils/process-log-async-router'
import { portalNextHostList } from '@/config/host'

NProgress.configure({ showSpinner: false })

function hasPermission(roles, permissionRoles) {
  if (!permissionRoles) return true
  // 只要用户拥有某路径路由配置中 roles 数组里面中某一项就认为该用户可访问该页面
  return roles.some((role) => permissionRoles.indexOf(role) >= 0)
}

function logout() {
  store.dispatch('LogOut')
}

const whiteList = [
  '/video-processor',
  '/auth',
  '/endcard2gif',
  '/tools/mw-viewer',
  '/mindwork-view',
]

router.beforeEach((to, from, next) => {
  NProgress.start()
  // debugger
  // 检查路径是否包含 /next
  if (to.path.includes('/nl')) {
    // 不包含 /next 时跳转
    // 注意：window.location 会完全离开当前应用
    const redirectUrl = `${portalNextHostList[NODE_ENV]}/#${to.fullPath}`
    console.log(redirectUrl, '跳转地址')
    console.log(NODE_ENV, '环境')
    window.location.href = redirectUrl
    return
  }

  const oldNext = next
  next = function () {
    store.commit('UPDATE_CURRENT_ROUTER', to)
    return oldNext.apply(null, arguments)
  }

  /**
   * 根据 roles 权限生成可访问的路由表
   * @param {[string]} roles
   */
  const generateRoutes = (roles) => {
    // console.log('打印路由表', processLogAsyncRouterMap(asyncRouterMap))
    store
      .dispatch('GenerateRoutes', { roles, asyncRouterMap, routerMap })
      .then(() => {
        console.log(
          '打印路由表',
          processLogAsyncRouterMap(store.getters.accessibleRouters),
        )
        router.addRoutes(store.getters.accessibleRouters) // 动态添加可访问路由表
        next({ ...to, replace: true }) // hack 方法 确保 addRoutes 已完成, set the replace: true so the navigation will not leave a history record
      })
  }

  const getUserInfo = () => {
    store
      .dispatch('GetUserInfo')
      .then((res) => {
        let roles = _.get(res, 'permissions') || []
        roles = roles.concat(['default'])
        generateRoutes(roles)

        if (isProduction || isPrerelease) {
          Sentry.setUser({
            id: String(res.info.id),
            email: res.info.email,
          })
        }
      })
      .catch(logout)
  }

  const navigateToHome = () => {
    next({ path: '/' })
    NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
  }

  const navigateTo404 = () => {
    next({ path: '/404', replace: true, query: { noGoBack: true } })
    NProgress.done()
  }

  // const navigateToVideoEditor = () => {
  //   const url = NODE_ENV === 'development' ? '//fe.dev.com:9728/#/template-list/template' : '/video-editor/#/template-list/template'
  //   window.open(url, '_blank')
  //   NProgress.done()
  // }

  if (getToken()) {
    // 已登录去了 auth 页面，跳转到首页
    if (/^\/auth/.test(to.path)) {
      navigateToHome()
      return
    }
    // if (to.path.indexOf('vmaker-list') !== -1) {
    //   navigateToVideoEditor()
    //   return
    // }
    if (store.getters.roles.length === 0) {
      // 初始化渠道列表
      initChannelList()
      // 获取用户信息
      getUserInfo()
      return
    }
    if (hasPermission(store.getters.roles, to.meta.roles)) {
      next()
    } else {
      navigateTo404()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      store.dispatch('Login') // 未登录用户访问白名单之外的页面去账号中心登陆或授权
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束 Progress
})

router.onError(() => {
  NProgress.done() // 结束 Progress
  console.log('onError')
})
